<template>
  <div class="account-options">
    <h2 class="page-subtitle pt-5">Account Options</h2>

    <b-row class="mt-4">
      <b-col md="6" sm="6">
        <b-button
          block
          variant="outline-danger"
          class="delete-btn"
          @click="change('delete')"
          >Delete Account</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Account Options
 * ==================================================================================
 **/

export default {
  methods: {
    change(field) {
      this.$router.push({
        name: 'user.change-page',
        params: {
          field: field
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.account-options {
  .delete-btn {
    font-weight: 400;
  }
}
</style>
